/**
 * This is a compiled JS file.
 * Changes here could be overwritten. 
 * Contact your Shopify developers if changes need to be made.
 */

document.addEventListener("DOMContentLoaded", function () {
  // === Handle variant tab click with delegation ===
  document.addEventListener("click", function (e) {
    const tab = e.target.closest(".variant-tab");
    if (!tab) return;

    const container = tab.closest(".variants-tab_container");
    if (!container) return;

    const cardWrapper = container.closest(".card__container"); // this wraps the full card

    // 👇 Now query scoped inside this card only
    const input = cardWrapper.querySelector(".variant-input");
    const priceContainer = cardWrapper.querySelector(".card_price_variants");

    // Update active class on variant tabs
    container
      .querySelectorAll(".variant-tab")
      .forEach((t) => t.classList.remove("variantsActive"));
    tab.classList.add("variantsActive");

    const variantId = tab.getAttribute("data-variant-id");
    const price = parseFloat(tab.getAttribute("data-price"));
    const comparePrice = parseFloat(tab.getAttribute("data-compare-price"));

    // Update hidden input for cart
    if (input) {
      input.value = variantId;
      input.setAttribute("data-variant-id", variantId);
    }

    // Update price UI
    let html = "";
    if (!isNaN(comparePrice) && comparePrice > price) {
      const savings = Math.round(((comparePrice - price) / comparePrice) * 100);
      html = `
      <div class="card__price">
        <span class="custom-card__compare_at_price">₹${comparePrice.toFixed(
          0
        )}</span>
        <span class="card__price__new">₹${price.toFixed(0)}</span>
        <span class="card__price__saving">Saving: ${savings}%</span>
      </div>
      <p class="custom-mrp-msg">MRP (incl. of all taxes)</p>
    `;
    } else {
      html = `
      <div class="card__price">
        <span class="card__price__new">₹${price.toFixed(0)}</span>
      </div>
      <p class="custom-mrp-msg">MRP (incl. of all taxes)</p>
    `;
    }

    if (priceContainer) {
      priceContainer.innerHTML = html;
    }
  });

  // === Handle quick add form submit with delegation ===
  document.addEventListener("submit", function (e) {
    const form = e.target.closest(".custom-quick-add-form");
    if (!form) return;

    e.preventDefault();

    const productId = form.dataset.productId;
    const input = document.getElementById(`variant-input-${productId}`);
    const variantId = input.value;

    const submitBtn = form.querySelector("button[type='submit']");
    if (!submitBtn) return;

    const originalHTML = submitBtn.innerHTML;
    submitBtn.disabled = true;
    submitBtn.innerHTML = `<span class="spinner"></span>`;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((res) => res.json())
      .then((data) => {
        const drawerBtn = document.querySelector(
          '[data-drawer-toggle="cart-drawer"]'
        );
        if (drawerBtn) drawerBtn.click();

        fetch("/?sections=cart-drawer")
          .then((res) => res.json())
          .then((sectionsJSON) => {
            const cartDrawerContainer = document.querySelector("cart-drawer");
            if (cartDrawerContainer) {
              cartDrawerContainer.innerHTML = sectionsJSON["cart-drawer"];
              updateUpsellProducts();
              observeCartChanges();
              shippingFree();
            }
          });
      })
      .catch((err) => {
        console.error("Error adding to cart:", err);
        alert("Something went wrong!");
      })
      .finally(() => {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalHTML;
      });
  });
});

// === Global Observer Ref ===
let cartObserver = null;
let lastCartProductIds = "";

// ✅ Fetch and render upsell products
const updateUpsellProducts = async () => {
  const cartItems = document.querySelectorAll(".cart-item");
  const uniqueUpsellMap = new Map();

  const currentIds = Array.from(cartItems)
    .map((item) => item.getAttribute("data-product-id"))
    .join(",");
  lastCartProductIds = currentIds;

  let hasValidUpsell = false;

  cartItems.forEach((item) => {
    const upsellRaw = item.getAttribute("data-upsell-products");
    if (!upsellRaw || upsellRaw === "null") return;

    try {
      const parsed = JSON.parse(upsellRaw);
      if (Array.isArray(parsed) && parsed.length > 0) {
        hasValidUpsell = true;
        parsed.forEach((upsellProduct) => {
          if (upsellProduct.id && upsellProduct.handle) {
            uniqueUpsellMap.set(upsellProduct.id, upsellProduct.handle);
          }
        });
      }
    } catch {
      console.warn("❌ Invalid upsell JSON:", upsellRaw);
    }
  });

  const customContainer = document.querySelector(
    ".custom-upsell-products-container"
  );
  if (!hasValidUpsell || uniqueUpsellMap.size === 0) {
    if (customContainer) customContainer.style.display = "none";
    return;
  }

  const finalUpsellProducts = [];

  await Promise.all(
    Array.from(uniqueUpsellMap).map(([id, handle]) =>
      fetch(`/products/${handle}.js`)
        .then((res) => res.json())
        .then((product) => {
          finalUpsellProducts.push({
            id: product.id,
            description: product.description,
            title: product.title,
            price: (product.price / 100).toFixed(2),
            compareAtPrice: product.compare_at_price
              ? (product.compare_at_price / 100).toFixed(2)
              : null,
            handle: product.handle,
            variantId: product.variants[0].id,
            image: product.images?.[0] || "",
          });
        })
        .catch((err) => console.error(`❌ Failed to fetch ${handle}`, err))
    )
  );

  const upsellContainer = document.querySelector(
    ".upsell-product-slider-container"
  );
  if (!upsellContainer) return;

  if (finalUpsellProducts.length > 0) {
    if (customContainer) customContainer.style.display = "block";

    upsellContainer.innerHTML = "";

    finalUpsellProducts.sort((a, b) => a.title.localeCompare(b.title));

    finalUpsellProducts.forEach((upsellProduct) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = upsellProduct.description;

      const keypointsDiv = tempDiv.querySelector("[data-upsell-keypoints]");
      const keypointsData =
        keypointsDiv?.getAttribute("data-upsell-keypoints") || "";
      const keypoints = keypointsData
        ? keypointsData
            .split(",")
            .map((point) => `<li>${point.trim()}</li>`)
            .join("")
        : "";

      const itemHTML = `
        <div class="upsell-item" data-upsell-keypoints="${keypoints}">
          <div class="upsell_image">
            <img src="${upsellProduct.image}" alt="${upsellProduct.title}">
          </div>
          <div class="upsell_content">
            <p class="upsell_title">${upsellProduct.title}</p>
            <ul class="upsell_content_pointers">${keypoints}</ul>
            <p class="price">
              ${
                upsellProduct.compareAtPrice
                  ? `<del>₹${upsellProduct.compareAtPrice
                      .toString()
                      .replace(/\.00$/, "")}</del>`
                  : ""
              }
              ₹${upsellProduct.price.toString().replace(/\.00$/, "")}
            </p>
${
  upsellProduct.compareAtPrice &&
  Number(upsellProduct.compareAtPrice) > Number(upsellProduct.price)
    ? (() => {
        const discount = Math.round(
          ((Number(upsellProduct.compareAtPrice) -
            Number(upsellProduct.price)) /
            Number(upsellProduct.compareAtPrice)) *
            100
        );
        return discount > 0
          ? `<p class="saving_percentage">${discount}% OFF</p>`
          : "";
      })()
    : ""
}

            <button class="add_to_cart_upsell" 
              data-product-handle="${upsellProduct.handle}"
              data-variant-id="${upsellProduct.variantId}">
              Add Now
            </button>
          </div>
        </div>
      `;
      upsellContainer.insertAdjacentHTML("beforeend", itemHTML);
    });

    await updateUpsellButtonStates();
  }
};

// ✅ Update upsell button state
const updateUpsellButtonStates = async () => {
  try {
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();
    const variantIdsInCart = cart.items.map((item) => item.variant_id);

    document.querySelectorAll(".add_to_cart_upsell").forEach((btn) => {
      const variantId = parseInt(btn.getAttribute("data-variant-id"));
      if (variantIdsInCart.includes(variantId)) {
        btn.textContent = "Remove";
        btn.classList.add("added");
      } else {
        btn.textContent = "Add Now";
        btn.classList.remove("added");
      }
    });
  } catch (err) {
    console.error("❌ Failed to update upsell button states:", err);
  }
};

// ✅ Debounced upsell update
let upsellUpdateTimeout;
const debouncedUpdateUpsells = () => {
  clearTimeout(upsellUpdateTimeout);
  upsellUpdateTimeout = setTimeout(updateUpsellProducts, 300);

  shippingFree();
};

// ✅ Observe cart for DOM changes
const observeCartChanges = () => {
  const cartContainer =
    document.querySelector(".cart-items") ||
    document.querySelector("#CartDrawer");

  if (!cartContainer) {
    console.warn("🛒 Cart container not found.");
    return;
  }

  if (cartObserver) cartObserver.disconnect();

  cartObserver = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
      const addedOrRemovedCartItem =
        Array.from(mutation.addedNodes).some((node) =>
          node.classList?.contains("cart-item")
        ) ||
        Array.from(mutation.removedNodes).some((node) =>
          node.classList?.contains("cart-item")
        );

      const quantityChanged =
        Array.from(
          mutation.target.querySelectorAll?.(".js-counter-quantity") || []
        ).length > 0;

      if (
        mutation.type === "childList" &&
        (addedOrRemovedCartItem || quantityChanged)
      ) {
        debouncedUpdateUpsells();
        break;
      }
    }
  });

  cartObserver.observe(cartContainer, {
    childList: true,
    subtree: true,
  });
};

// ✅ Handle upsell button clicks (add/remove)
document.addEventListener("click", async function (e) {
  const btn = e.target.closest(".add_to_cart_upsell");
  if (!btn) return;

  const variantId = parseInt(btn.getAttribute("data-variant-id"));

  try {
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();
    const existingItem = cart.items.find(
      (item) => item.variant_id === variantId
    );

    btn.disabled = true;
    btn.textContent = existingItem ? "Removing..." : "Adding...";

    if (existingItem) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: existingItem.key, quantity: 0 }),
      });
    } else {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
    }

    const sectionsRes = await fetch("/?sections=cart-drawer");
    const sectionsJSON = await sectionsRes.json();
    const cartDrawerContainer = document.querySelector("cart-drawer");
    if (cartDrawerContainer) {
      cartDrawerContainer.innerHTML = sectionsJSON["cart-drawer"];
      debouncedUpdateUpsells();
      observeCartChanges();
    }
  } catch (err) {
    console.error("❌ Error updating upsell product:", err);
  } finally {
    btn.disabled = false;
  }
});


// Free Shipping Function
const shippingFree = async () => {
  const cart = await getCart();
  if (!cart) return;

  const actualTargetPrice = cart.total_price / 100;
  const shippingTargetPrice = 429;

  const messageEl = document.getElementById("shipping-message");
  const progressBar = document.getElementById("progress-bar");
  const progressText = document.getElementById("progress-text");

  // Calculate progress %
  let progress = Math.min(Math.round((actualTargetPrice / shippingTargetPrice) * 100), 100);

  // Update message
  if (actualTargetPrice >= shippingTargetPrice) {
    messageEl.innerHTML = `🎉 Congratulations! You unlocked <b>FREE</b> Shipping!`;
  } else {
    const remaining = shippingTargetPrice - actualTargetPrice;
    messageEl.innerHTML = `Add <b>₹${remaining}</b> more to unlock FREE shipping!`;
  }

  // Animate progress bar width
  const currentWidth = parseFloat(progressBar.style.width) || 0; // get current width %
  progressBar.style.transition = "width 0.45s ease";
  progressBar.style.width = progress + "%";

  // Animate numeric count
  const start = currentWidth;
  const end = progress;

  const duration = 450; // ms
  const stepTime = 20;
  const steps = Math.ceil(duration / stepTime);
  let stepCount = 0;

  function animateCount() {
    stepCount++;
    const value = Math.round(start + ((end - start) * stepCount) / steps);
    progressText.innerText = value + "%";

    if (stepCount < steps) {
      setTimeout(animateCount, stepTime);
    }
  }

  animateCount();
};


// --- Cart Fetch Function ---
const getCart = async () => {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    return cart; // full cart object
  } catch (err) {
    console.error("Error fetching cart:", err);
    return null;
  }
};


// ✅ Init on page load
window.addEventListener("load", () => {
  updateUpsellProducts();
  observeCartChanges();
  shippingFree()
});
